module.exports = __webpack_public_path__ + "media/images/pic04-5bfa98bba45be56c73364a168f324031.jpg";